var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedManagementIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 27.5V3.5H24.5V21.4678C25.083 21.7575 25.5943 22.17 26 22.6713V3C26 2.44772 25.5523 2 25 2H4C3.44772 2 3 2.44771 3 3V28C3 28.5523 3.44772 29 4 29H19.6713C19.17 28.5943 18.7575 28.083 18.4678 27.5H4.5ZM25.4639 28.8861C25.644 28.7917 25.7917 28.644 25.8861 28.4639C25.7548 28.6138 25.6138 28.7548 25.4639 28.8861Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H21.5M8 11H21.5M8 15H21.5M8 19H16.5",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22C23.5 22 26.5 25.5 26.5 28.5M20.5 25C22 25 23.5 27 23.5 28.5",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28C21 28.2761 20.7761 28.5 20.5 28.5C20.2239 28.5 20 28.2761 20 28C20 27.7239 20.2239 27.5 20.5 27.5C20.7761 27.5 21 27.7239 21 28Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedManagementIcon);
export default __webpack_public_path__ + "static/media/feed-management-icon.1261e7c7bb49d9f020e262773c2ef6c3.svg";
export { ForwardRef as ReactComponent };